const radioStyle: React.CSSProperties = {
  width: 14,
  height: 14,
  borderRadius: '50%',
  border: '2px solid #4b5563',
  flexShrink: 0,
};
const radioActiveStyle: React.CSSProperties = {
  ...radioStyle,
  border: '2px solid #22d3ee',
  background: 'radial-gradient(circle, #22d3ee 40%, transparent 45%)',
};

const sliderTrack: React.CSSProperties = {
  height: 4,
  background: '#1e1e2e',
  borderRadius: 2,
  position: 'relative',
  margin: '0.625rem 0 0.375rem',
};

const sliderThumb = (color: string): React.CSSProperties => ({
  width: 12,
  height: 12,
  borderRadius: '50%',
  background: color,
  position: 'absolute',
  top: -4,
  left: '0%',
});

export default function ConfigSafetyMock() {
  return (
    <div className="platform-mock mock-sidebar">
      <div className="platform-mock-header"><span className="dot" /> Fees &amp; Safety Constraints <span style={{ fontWeight: 400, color: '#4b5563', textTransform: 'none', letterSpacing: 0, fontSize: '0.5625rem' }}>(optional)</span></div>
      <div className="platform-mock-body">

        {/* Fees */}
        <div className="mock-sidebar-section">
          <div className="mock-sidebar-heading"><span className="chevron">&#9662;</span> FEES</div>
          <div className="mock-sidebar-row">
            <span className="mock-sidebar-label">Trading Fee</span>
            <span className="mock-sidebar-val" style={{ fontWeight: 700 }}>0.1%</span>
          </div>
        </div>

        {/* Safety Constraints */}
        <div className="mock-sidebar-section">
          <div className="mock-sidebar-heading"><span className="chevron">&#9662;</span> SAFETY CONSTRAINTS</div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '0.375rem', marginBottom: '0.5rem' }}>
            <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', cursor: 'default' }}>
              <span style={radioStyle} />
              <span style={{ fontSize: '0.6875rem', color: '#9ca3af' }}>Use strategy-defined rules</span>
            </label>
            <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', cursor: 'default' }}>
              <span style={radioActiveStyle} />
              <span style={{ fontSize: '0.6875rem', color: '#e5e7eb', fontWeight: 600 }}>Override for this run</span>
            </label>
          </div>
          <div style={{ fontSize: '0.5625rem', color: '#f59e0b', marginBottom: '0.75rem', fontStyle: 'italic' }}>
            Overrides may affect comparability with previous runs
          </div>
          {[
            { label: 'Max Loss Per Trade', value: 'None', color: '#ef4444' },
            { label: 'Profit Target', value: 'None', color: '#22c55e' },
            { label: 'Trailing Protection', value: 'Disabled', color: '#f59e0b' },
            { label: 'Slippage (per fill)', value: '0.1%', color: '#9d4edd' },
          ].map((s) => (
            <div key={s.label} style={{ marginBottom: '0.625rem' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.125rem' }}>
                <span style={{ fontSize: '0.6875rem', color: '#9ca3af' }}>{s.label}</span>
                <span style={{ fontSize: '0.6875rem', color: '#e5e7eb', fontWeight: 600 }}>{s.value}</span>
              </div>
              <div style={sliderTrack}>
                <div style={sliderThumb(s.color)} />
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="platform-mock-caption">Trading fee, stop-loss, take-profit, trailing stops, and simulated slippage.</div>
    </div>
  );
}
